
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
export class ConfirmPopUp extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    //this.setState({ show: false });
  }

  handleShow() {
    //this.setState({ show: true });
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose} data-test-id="information-pop-up-window">
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title || 'Inforrmation'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.contentText}</Modal.Body>
        <Modal.Footer>
          {(this.props.isCancel) ?
            <Button variant="secondary" onClick={this.props.onClose}>
              Cancel
                </Button> : null
          }
          <Button variant="primary" onClick={this.props.onConfirm} data-test-id="pop-up-ok">
            OK
              </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
